import { Entity } from "@/core/common/Entity";

type SaldoDevedorData = {
  principal: number;
  multa: number;
  juros: number;
  total: number;
};

export default class SaldoDevedor extends Entity<SaldoDevedorData> {
  private constructor(params: SaldoDevedorData) {
    super(params);
  }

  static create(params: SaldoDevedorData) {
    return new SaldoDevedor(params);
  }

  getProps(): SaldoDevedorData {
    return this.props;
  }
}
